import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { asThemeConsumer } from "../../../theme/Theme";
/**
 *
 * @param props
 */
var LabelComp = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-a-label__field");
    return !props.children
        ? null
        : (React.createElement("label", { className: clazzName }, props.children));
};
/**
 *
 */
export var Label = asThemeConsumer(LabelComp);
